import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard, NoddiSeparator } from 'noddi-ui-web';
import { useLanguageContext } from 'noddi-web';
import { MaintenanceScreen as MaintenanceScreenType } from '../../utils/remoteConfigSetup';
import { ContentWrapperCustomerApp } from '../Layouts/ContentWrapperCustomerApp';
import { CustomerHeaderNav } from '../Layouts/CustomerHeaderNav';

export const MaintenanceScreen = ({ maintenanceScreen }: { maintenanceScreen: MaintenanceScreenType }) => (
  <div className='min-h-screen bg-primary-background-gradient'>
    <CustomerHeaderNav />
    <MaintenanceContent maintenanceScreen={maintenanceScreen} />
  </div>
);

export const MaintenanceContent = ({ maintenanceScreen }: { maintenanceScreen: MaintenanceScreenType }) => {
  const { currentLanguage } = useLanguageContext();

  const getCurrentLanguageText = (text: MaintenanceScreenType['title']) => {
    switch (currentLanguage) {
      case 'se':
        return text.swedish;
      case 'nb':
        return text.norwegian;
      case 'en':
        return text.english;
    }
  };

  const title = getCurrentLanguageText(maintenanceScreen.title);
  const subtitle = getCurrentLanguageText(maintenanceScreen.subtitle);
  return (
    <ContentWrapperCustomerApp hideBackButton width='lg'>
      <div className='mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center p-4 text-center md:p-10'>
        <NoddiBasicCard className='flex flex-col gap-1.5'>
          <div className='flex items-start gap-2'>
            <NoddiIcon name='Info' className='fill-primary text-white' size='medium' />
            <h3>{title}</h3>
          </div>
          <div className='ml-8 text-sm text-muted-foreground'>{subtitle}</div>
          <NoddiSeparator className='my-2' />
          <div className='flex items-start gap-2'>
            <NoddiIcon name='Wrench' size='xMedium' className='mt-1' />
            <h3>{t`We are working on resolving the issue.`}</h3>
          </div>
          <div className='ml-8 text-sm text-muted-foreground'>{t`Our team is working on resolving the issue as soon as possible. We´re sorry for the inconvenience.`}</div>
          <p className='mt-4 text-center text-sm text-muted-foreground'>
            <Trans>Thank you for your patience.</Trans>
          </p>
        </NoddiBasicCard>
      </div>
    </ContentWrapperCustomerApp>
  );
};
